/** URL param that carries promo codes */
export const PROMO_CODES_URL_PARAM = 'code[]'
